import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { setProductList } from '../../../../../store/actions/index'
import legoService from '../../../../../services/lego'
import {
  Radio,
  Select,
  message,
  Slider,
  InputNumber,
  Input,
  Row,
  Col,
  TreeSelect,
  Button,
  Form,
} from 'antd'
import utils from 'bxl-utils'
import BrandSelect from '../../../../../components/BrandSelect'
import { SORT_TYPE } from '../../../../../lib/constant'
import { merchantCategories } from '../../../../../lib/constant'
const { TreeNode } = TreeSelect

const Option = Select.Option
const RadioGroup = Radio.Group
const { TextArea } = Input
import { withTranslation } from 'react-i18next'
type Badge =
  | 'TOP'
  | 'HOT'
  | 'NEW'
  | 'HOLD'
  | 'WORTH'
  | 'SPIKE'
  | 'EXCLUSIVE'
  | 'POSTAGE_REDUCTION'
  | 'FREE_SHIPPING'
interface IProductListConfig {
  productRow: number
  tags?: string[]
  excludedTags?: string[]
  ids?: string[]
  parseType: string
  maxProductNum?: number
  merchantList?: string[]
  brandList?: string[]
  excludedBrands?: string[]
  sortType?: string
  discountRange?: [number, number]
  priceList?: [number, number]
  categoryIds?: string[]
  excludedCategories?: string[]
  labels?: string[]
  filterSellOut?: number
  promoId?: string[]
  q?: string
  meta?: {
    badge?: {
      type: Badge
      value: number
    }
  }
  excludeLabels?: string[]
}

export interface IProductListProps {
  id: string
  config: IProductListConfig
  pid: string
  setProductIds: Function
  setProductList: Function
  setProductRow: Function
  setParseProductType: Function
  setProductNum: Function
  setSearchQuery: Function
  setProductMeta: (value) => void
  t: (str: string, data?: any) => string
  merchants: any[]
}
interface IStateProps {
  channel?: string
}
const badgeMap = {
  TOP: 'TOP',
  HOT: '热',
  NEW: '新',
  HOLD: '顶',
  WORTH: '值',
  SPIKE: '秒',
  EXCLUSIVE: '独家',
  POSTAGE_REDUCTION: '减邮',
  FREE_SHIPPING: '免邮',
}
const promoTypeList = ['coupon', 'discount', 'newcomer']

const discountRegex = /(tlc:|tlcm:|tlchc:|tlcr:)/i
const newcomerRegex = /(tlcn:)/i

const mapDispatchToprops = (dispatch, ownProps: IProductListProps) => ({
  setProductIds: (ids: string[]) => {
    dispatch(setProductList('ids', ids, ownProps.id))
  },
  setProductList: (products: any[]) => {
    dispatch(setProductList('products', products, ownProps.id))
  },
  setProductRow: (value: number) => {
    dispatch(setProductList('productRow', value, ownProps.id))
  },
  setParseProductType: (type: string) => {
    dispatch(setProductList('parseType', type, ownProps.id))
  },
  setProductNum: value => {
    dispatch(setProductList('maxProductNum', value, ownProps.id))
  },
  setSearchQuery: (type, value) => {
    dispatch(setProductList(type, value, ownProps.id))
  },
  setProductMeta: value => {
    dispatch(setProductList('meta', value, ownProps.id))
  },
})
const mapStateToProps = state => ({
  channel: state.tree.root.config.channel,
  merchants: state.baseData.merchants,
})
const formItemLayout = {
  labelCol: {
    xs: {
      span: 6,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 18,
    },
    sm: {
      span: 18,
    },
  },
}
const badgeItemLayout = {
  labelCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
}

const renderSelect = (
  mode: 'multiple' | 'tags',
  values: Array<string> | undefined,
  label: string,
  placeholder: string,
  options: Array<any>,
  errorInput: any,
  onChange: any
) => {
  return (
    <Form.Item {...formItemLayout} label={label}>
      <Select
        mode={mode}
        placeholder={placeholder}
        style={errorInput ? { borderColor: 'red' } : {}}
        value={values || []}
        onChange={onChange}
      >
        {options.map((item: any) => {
          // eslint-disable-next-line react/jsx-key
          return <Option value={item.id}>{item.id}</Option>
        })}
      </Select>
    </Form.Item>
  )
}

const treeSelect = (children: any, parentName?: string) => {
  return children && children.length > 0 ? (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    children.map((item: any, index: number) => {
      return (
        <TreeNode
          value={item.category.id}
          title={`${item.category.id}-${parentName ? parentName + '-' : ''}${
            item.category.displayTerm
          }(${item.category.term})`}
          key={item.category.id}
        >
          {item.children &&
            item.children.length > 0 &&
            treeSelect(
              item.children,
              `${parentName ? parentName + '-' : ''}${item.category.displayTerm}`
            )}
        </TreeNode>
      )
    })
  ) : (
    <div></div>
  )
}

class ProductList extends Component<IProductListProps & IStateProps> {
  state = {
    errorInput: false,
    categoryTree: [],
    promocodeList: [],
    promoCode: '',
    promoCodesList: {
      coupon: [],
      discount: [],
      newcomer: [],
    },
    promoType: '',
  }

  constructor(props) {
    super(props)
    if (props.config && !props.config.parseType) {
      props.setParseProductType('id')
      props.setProductRow(2)
    }
    this.handleSelectChange = utils.debounce(500, this.handleSelectChange.bind(this))
    this.getProducts = utils.debounce(1000, this.getProducts.bind(this))
  }
  componentDidMount() {
    this.getCategories()
  }
  getCategories = () => {
    legoService
      .getCategories()
      .then(res => {
        this.setState({
          categoryTree: res.data.children,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }
  onParseTypeChange = (value: string) => {
    this.props.setProductIds([])
    this.props.setProductList([])
    this.props.setParseProductType(value)
    this.props.setProductNum(20)
    this.props.setProductMeta({})
  }
  getPromocodeList = merchantId => {
    legoService
      .getMerchantPromocode(merchantId)
      .then(res => {
        if (res.data) {
          const discountArr: any = [],
            newcomerArr: any = [],
            couponArr: any = []
          res?.data?.forEach(item => {
            const codesStr = item?.spec?.codes?.join(',')
            if (newcomerRegex.test(codesStr)) {
              newcomerArr.push(item)
            } else if (discountRegex.test(codesStr)) {
              discountArr.push(item)
            } else {
              couponArr.push(item)
            }
          })
          this.setState({
            promoCodesList: {
              coupon: couponArr,
              discount: discountArr,
              newcomer: newcomerArr,
            },
          })
        } else {
          message.error(res.response.data)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  setPromoCode = value => {
    this.props.setSearchQuery('promoId', value)
  }

  onIdsChange = (ids: string[]) => {
    this.setState({
      errorInput: false,
    })
    this.getProducts(ids)
  }

  changeProducIds = value => {
    let ids = value.replace(' ', '')
    const reg = new RegExp(/\n/g)
    ids = ids.split(reg).join(',').split(',')
    this.props.setProductIds(ids)
    this.getProducts(ids)
    const meta = this.props.config?.meta || {}
    this.props.setProductMeta(
      ids.reduce((init, item) => {
        if (meta[item]) {
          init[item] = meta[item]
        }
        return init
      }, {})
    )
  }

  getProducts = (ids: string[]) => {
    if (!ids || ids.length === 0) {
      return
    }
    const hide = message.loading(this.props.t('productLoading'), 0)
    legoService
      .getProductsList(ids)
      .then(res => {
        this.props.setProductList(res.data)
        this.props.setProductIds(ids)
        hide()
      })
      .catch(err => {
        hide()
        if (err.response) {
          message.error(err.response.data)
        }
      })
  }

  numChange(num) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const tags = this.props.config.ids || []
    this.props.setProductNum(num)
    // this.handleSelectChange(tags)
  }
  handleSelectChange = () => {
    this.setState({
      errorInput: false,
    })
    // this.props.setProductIds(tags);
    const {
      tags,
      excludedTags,
      merchantList,
      brandList,
      excludedBrands,
      discountRange,
      priceList,
      categoryIds,
      excludedCategories,
      labels,
      sortType,
      promoId,
      q,
      excludeLabels,
    } = this.props.config

    const maxNum = this.props.config.maxProductNum ? this.props.config.maxProductNum : 20
    const query = {
      ntg: excludedTags,
      tg: tags,
      m: merchantList,
      b: brandList,
      dr: discountRange ? `${(10 - discountRange[1]) * 10}-${(10 - discountRange[0]) * 10}` : null,
      prs: priceList ? `${priceList[0] * 100}-${priceList[1] * 100}` : null,
      cids: categoryIds,
      nb: excludedBrands,
      ncids: excludedCategories,
      l2: labels,
      f: 0,
      t: maxNum,
      s: sortType || 'sales',
      nc: true,
      promoId,
      q,
      nl: excludeLabels,
    }
    const hide = message.loading(this.props.t('productLoading'), 0)
    // 预览只显示前20个
    const domain = this.props.channel
      ? `https://santa-${this.props.channel}.santasmartnetwork.com`
      : ''
    legoService
      .searchProducts(query, domain)
      .then((res: any) => {
        message.success(this.props.t('proviewProduct', { maxNum }), 2)

        const productList = res.data.products
          .filter((p: any) => p.type === 'PRODUCT' && p.searchProduct !== null)
          .map((p: any) => p.searchProduct)
        this.props.setProductList(productList)
        this.props.setProductIds(tags)
        hide()
        this.setState({
          errorInput: false,
        })
      })
      .catch(err => {
        hide()
        if (err.response) {
          message.error(err.response.data)
        }
        this.setState({
          errorInput: true,
        })
      })
  }

  changeSearchQuery = (type, value) => {
    this.props.setSearchQuery(type, value)
  }

  setPriceRange = (type, value) => {
    const priceList = this.props.config.priceList
    let priceArr = [] as number[]
    if (priceList) {
      priceArr = Array.from(priceList)
      if (type === 'fromPrice') {
        priceArr[0] = value
      } else {
        priceArr[1] = value
      }
    } else {
      priceArr = []
      if (type === 'fromPrice') {
        priceArr[0] = value
        priceArr[1] = 2000
      } else {
        priceArr[1] = value
        priceArr[0] = 0
      }
    }
    this.changeSearchQuery('priceList', priceArr)
  }
  searchByQuery = () => {
    this.handleSelectChange()
  }
  onBadgeChange = (id, value) => {
    this.props.setProductMeta({
      ...(this.props.config?.meta || {}),
      [id]: {
        badge: {
          type: value,
        },
      },
    })
  }
  onBadgetTopChange = (id, value) => {
    this.props.setProductMeta({
      ...(this.props.config?.meta || {}),
      [id]: {
        badge: {
          type: 'TOP',
          value,
        },
      },
    })
  }
  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { errorInput, categoryTree, promoCode, promoCodesList, promoType } = this.state

    let { config } = this.props
    const { t } = this.props
    config = config || {}
    const {
      ids,
      productRow,
      parseType,
      filterSellOut,
      maxProductNum,
      merchantList,
      brandList,
      sortType,
      discountRange,
      priceList,
      categoryIds,
      tags,
      excludedTags,
      excludedBrands,
      excludedCategories,
      labels,
      promoId,
      q,
      meta = {},
      excludeLabels,
    } = config
    // todo get all tags
    const options: Array<any> = []
    const categoryTreeNode = treeSelect(categoryTree)
    return (
      <div className="productsContent">
        <Form className="productListConfig">
          <Form.Item {...formItemLayout} label={t('productType')}>
            <RadioGroup onChange={e => this.onParseTypeChange(e.target.value)} value={parseType}>
              <Radio value={'id'}>{t('baseOnID')}</Radio>
              <Radio value={'tag'}>{t('baseOnSearch')}</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('filterSoldOut')}>
            <RadioGroup
              onChange={e => this.changeSearchQuery('filterSellOut', e.target.value)}
              value={filterSellOut || 0}
            >
              <Radio value={1}>{t('yes')}</Radio>
              <Radio value={0}>{t('no')}</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('productLayout')}>
            <RadioGroup
              onChange={e => this.props.setProductRow(e.target.value)}
              value={productRow || 2}
            >
              <Radio value={1}>{t('vertical')}</Radio>
              <Radio value={2}>{t('columns2')}</Radio>
              <Radio value={3}>{t('columns3')}</Radio>
              <Radio value={'row'}>{t('horizonal')}</Radio>
            </RadioGroup>
          </Form.Item>
          {parseType === 'tag' && (
            <Form.Item {...formItemLayout} label={t('sizeLimit')}>
              <Row>
                <Col span={12}>
                  <Slider
                    min={3}
                    max={100}
                    onChange={value => this.numChange(value)}
                    value={typeof maxProductNum === 'number' ? maxProductNum : 20}
                  />
                </Col>
                <Col span={4}>
                  <InputNumber
                    min={3}
                    max={100}
                    style={{ marginLeft: 16 }}
                    value={maxProductNum || 20}
                    onChange={value => this.numChange(value)}
                  />
                </Col>
              </Row>
            </Form.Item>
          )}
          {parseType !== 'tag' && (
            <Form.Item {...formItemLayout} label={t('productId')}>
              <TextArea
                value={ids || []}
                autoSize={{ minRows: 3 }}
                onChange={e => this.changeProducIds(e.target.value)}
                placeholder="请输入商品id后回车或者加逗号分割"
              />
            </Form.Item>
          )}
          {parseType !== 'tag' &&
            productRow === 1 &&
            (ids || []).map(id => {
              return (
                <Fragment key={id}>
                  <Form.Item label={id} {...badgeItemLayout}>
                    <Select
                      value={meta[id] ? meta[id].badge?.type : ''}
                      onChange={e => {
                        this.onBadgeChange(id, e)
                      }}
                    >
                      {Object.entries(badgeMap).map(([key, val]) => (
                        <Select.Option key={key} value={key}>
                          {val}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {meta[id] && meta[id].badge?.type === 'TOP' && (
                    <Form.Item label="value" {...badgeItemLayout}>
                      <InputNumber
                        onChange={value => {
                          this.onBadgetTopChange(id, value)
                        }}
                        min={1}
                        step={1}
                        precision={0}
                      ></InputNumber>
                    </Form.Item>
                  )}
                </Fragment>
              )
            })}
          {parseType === 'tag' && (
            <Form.Item {...formItemLayout} label={t('keyword')}>
              <Input
                value={q || ''}
                onChange={e => this.changeSearchQuery('q', e.target.value)}
                placeholder="please input keyword"
              />
            </Form.Item>
          )}
          {parseType === 'tag' && (
            <div>
              <Form.Item {...formItemLayout} label={t('tags')}>
                <Select
                  mode="tags"
                  placeholder={t('tags')}
                  style={errorInput ? { borderColor: 'red' } : {}}
                  value={tags || []}
                  onChange={val => this.changeSearchQuery('tags', val)}
                >
                  {options.map(item => {
                    // eslint-disable-next-line react/jsx-key
                    return <Option value={item.id}>{item.id}</Option>
                  })}
                </Select>
              </Form.Item>
              {renderSelect(
                'tags',
                excludedTags,
                t('excludeTags'),
                t('excludeTags'),
                [],
                errorInput,
                (val: any) => this.changeSearchQuery('excludedTags', val)
              )}
              <Form.Item {...formItemLayout} label={t('sort')}>
                <Select
                  style={{ width: 200 }}
                  value={sortType || ''}
                  onChange={e => this.changeSearchQuery('sortType', e)}
                >
                  {SORT_TYPE.map(item => {
                    return (
                      <Option value={item.value} key={item.value}>
                        {t(item.label)}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('promoCode')}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t('productMerchant')}
                  filterOption={(input, option) =>
                    option && option.children
                      ? option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                      : false
                  }
                  onChange={this.getPromocodeList}
                >
                  {[...merchantCategories, ...this.props.merchants].map(item => {
                    // eslint-disable-next-line react/jsx-key
                    return <Option value={item['id']}>{item['label']}</Option>
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                label={
                  <div>
                    <Select
                      placeholder={t('promoCode')}
                      onChange={v => this.setState({ promoType: v })}
                    >
                      {promoTypeList &&
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        promoTypeList.map((item: any, index) => {
                          // eslint-disable-next-line react/jsx-key
                          return <Option value={item}>{item}</Option>
                        })}
                    </Select>
                  </div>
                }
              >
                <Select
                  showSearch
                  mode="tags"
                  optionFilterProp="children"
                  placeholder={t('promoCode')}
                  value={promoId || []}
                  filterOption={(input, option) =>
                    option && option.children
                      ? option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                      : false
                  }
                  onChange={this.setPromoCode}
                >
                  {promoCodesList?.[promoType] && promoCodesList?.[promoType]?.length
                    ? // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      promoCodesList?.[promoType]?.map((item: any, index) => {
                        // eslint-disable-next-line react/jsx-key
                        return <Option value={item.spec.id}>{item['spec']['name']}</Option>
                      })
                    : null}
                </Select>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('productMerchant')}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  mode="tags"
                  placeholder={t('productMerchant')}
                  style={errorInput ? { borderColor: 'red' } : {}}
                  value={merchantList || []}
                  filterOption={(input, option) =>
                    option && option.children
                      ? option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                      : false
                  }
                  onChange={e => this.changeSearchQuery('merchantList', e)}
                >
                  {[...merchantCategories, ...this.props.merchants].map(item => {
                    // eslint-disable-next-line react/jsx-key
                    return <Option value={item['id']}>{item['label']}</Option>
                  })}
                </Select>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('brand')}>
                <BrandSelect
                  brandList={brandList}
                  mode={'tags'}
                  placeholder={t('brand')}
                  handleChange={val => this.changeSearchQuery('brandList', val)}
                ></BrandSelect>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('excludeBrand')}>
                <BrandSelect
                  brandList={excludedBrands}
                  mode={'tags'}
                  placeholder={t('excludeBrand')}
                  handleChange={val => this.changeSearchQuery('excludedBrands', val)}
                ></BrandSelect>
              </Form.Item>
              <Form.Item {...formItemLayout} label="label">
                <Select
                  mode="tags"
                  value={labels}
                  placeholder="labels"
                  onChange={val => this.changeSearchQuery('labels', val)}
                >
                  <Option value="lowest_price">lowest_price</Option>
                </Select>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('excludeLabels')}>
                <Select
                  mode="tags"
                  value={excludeLabels}
                  placeholder="exclude babels"
                  onChange={val => this.changeSearchQuery('excludeLabels', val)}
                >
                  <Option value="pre_owned">pre_owned</Option>
                </Select>
              </Form.Item>
              <Form.Item {...formItemLayout} label="categorys">
                <TreeSelect
                  showSearch
                  style={{ width: 300 }}
                  value={categoryIds || []}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="Please select"
                  allowClear
                  multiple
                  // treeDefaultExpandAll
                  onChange={val => this.changeSearchQuery('categoryIds', val)}
                >
                  {treeSelect(categoryTree)}
                </TreeSelect>
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('excludeCategory')}>
                {categoryTreeNode && (
                  <TreeSelect
                    showSearch
                    style={{ width: 300 }}
                    value={excludedCategories || []}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder={t('excludeCategory')}
                    allowClear
                    multiple
                    // treeDefaultExpandAll
                    onChange={val => this.changeSearchQuery('excludedCategories', val)}
                  >
                    {categoryTreeNode}
                  </TreeSelect>
                )}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('discountRange')}>
                <Slider
                  style={{ width: 300 }}
                  range
                  min={0}
                  max={10}
                  tooltipVisible
                  marks={{
                    0: this.props.t('discount0'),
                    10: {
                      style: {
                        color: '#f50',
                      },
                      label: <strong>{this.props.t('discount100')}</strong>,
                    },
                  }}
                  defaultValue={[0, 10]}
                  onChange={value => this.changeSearchQuery('discountRange', value)}
                  value={discountRange || [0, 10]}
                  step={0.1}
                />
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('priceRange')}>
                <InputNumber
                  min={0}
                  value={(priceList && priceList[0]) || undefined}
                  formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value => (value ? value.replace(/\$\s?|(,*)/g, '') : '')) as any}
                  onChange={val => this.setPriceRange('fromPrice', val)}
                />
                -{' '}
                <InputNumber
                  value={(priceList && priceList[1]) || undefined}
                  formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value => (value ? value.replace(/\$\s?|(,*)/g, '') : '')) as any}
                  onChange={val => this.setPriceRange('toPrice', val)}
                />
              </Form.Item>
              <Form.Item {...formItemLayout}>
                <Button onClick={this.searchByQuery}>{t('confirm')}</Button>
              </Form.Item>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToprops)(withTranslation()(ProductList))
